import { HariseninFooter } from "@components/harisenin"
import { Header } from "@components/header"
import Helmet from "@helpers/Helmet"
import { BannerInfo } from "@interfaces/misc"
import { ContactUs } from "@modules/contact-us/ContactUs"
import { FC } from "react"
import { FAQSection } from "./components/FAQSection"
import { HelpCta } from "./components/HelpCta"
import { HomeBanner } from "./components/HomeBanner"
import { OurProgram } from "./components/OurProgram"
import { ProjectSection } from "./components/ProjectSection"
import { TestimonialSection } from "./components/TestimonialSection"
import { WhyUs } from "./components/WhyUs"

export interface LandingPageProps {
  infoAlumni: BannerInfo | null
}

const LandingPage: FC<LandingPageProps> =({ infoAlumni }) => {
  return (
    <>
      <Helmet isIndexed />
      <Header />
      <HomeBanner />
      <WhyUs info={infoAlumni} />
      <OurProgram />
      <HelpCta />
      {/* <CorporateStatistic /> */}
      {/* <OurClient /> */}
      <ProjectSection />
      <TestimonialSection />
      <FAQSection />
      <ContactUs />
      <HariseninFooter />
    </>
  )
}

export default LandingPage
